import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VDistpicker from 'v-distpicker'
import axios from 'axios'
import qs from 'qs'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
// 图片预览插件 vue-photo-preview
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
// import clickoutside from './js/clickoutside.js'
// import clickoutside from 'element-ui/src/utils/clickoutside'

import eruda from 'eruda'

const ua = navigator.userAgent
// 是安卓、iphone 或者 ipad，才显示
if (ua.match(/Android/i) !== null || ua.match(/iPad|iPod|iPhone/i) !== null) {
  eruda.init()
}

Vue.use(preview)
Vue.use(MintUI)
Vue.config.productionTip = false
Vue.use(ElementUI, { zIndex: 1000 })
Vue.component('v-distpicker', VDistpicker)
// Vue.directive('clickout', clickoutside);

Vue.prototype.$axios = axios
Vue.prototype.$qs = qs;
// Vue.prototype.$baseURL = "http://127.0.0.1:8088";   // 请求后台数据
// Vue.prototype.$uploadURL = "http://127.0.0.1:8088/upload/uploadwork";   // 图片上传接口
// Vue.prototype.$baseURL = "http://10.10.40.7:8091/bullfast";   // 请求后台数据
// Vue.prototype.$uploadURL = "http://10.10.40.7:8091/bullfast/upload/uploadwork";   // 图片上传接口
Vue.prototype.$baseURL = "http://bcss.gongniu.cn/appoint/bullfast";   // 请求后台数据   --- 正式
Vue.prototype.$uploadURL = "http://bcss.gongniu.cn/appoint/bullfast/upload/uploadwork";   // 图片上传接口   --- 正式
// Vue.prototype.$uploadURL = "http://bcss.gongniu.cn:8090/fileUpload/upload/uploadwork"; // 外网地址，返回的是lookup路径


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
